import { UsersStateInterface } from '.';

function state(): UsersStateInterface {
  return {
    users: [],
  };
}

export default state;
